import { lazyWithRecovery as lazy } from 'utils/lazyWithRecovery';

// project import
import MainLayout from 'layout/MainLayout';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// pages routing
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

// render - home page
const HomePage = Loadable(lazy(() => import('pages/home/home-page')));

// map pages routing
const MapPage = Loadable(lazy(() => import('pages/map/map-page')));

// render - data pages
const FilesPage = Loadable(lazy(() => import('pages/data/files-page')));
const ProjectsPage = Loadable(lazy(() => import('pages/data/projects-page')));
const ListsPage = Loadable(lazy(() => import('pages/data/lists-page')));

// render - settings pages
const AccountPage = Loadable(lazy(() => import('pages/settings/account-page')));
const EstatesPage = Loadable(lazy(() => import('pages/settings/estates-page')));
const TeamAndContactsPage = Loadable(lazy(() => import('pages/teamAndContacts/teamAndContacts-page')));
const ProfilePage = Loadable(lazy(() => import('pages/settings/profile-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          index: true, // This makes "home-page" the default child route
          element: <HomePage />
        },
        {
          path: 'home-page/*',
          element: <HomePage />
        },
        {
          path: 'map-page/*',
          element: <MapPage />
        },
        {
          path: 'files-page/*',
          element: <FilesPage />
        },
        {
          path: 'projects-page/*',
          element: <ProjectsPage />
        },
        {
          path: 'lists-page/*',
          element: <ListsPage />
        },
        {
          path: 'estates-page/*',
          element: <EstatesPage />
        },
        {
          path: 'team-and-contacts-page/*',
          element: <TeamAndContactsPage />
        },
        {
          path: 'account-page/*',
          element: <AccountPage />
        },
        {
          path: 'profile-page/*',
          element: <ProfilePage />
        }
      ]
    },
    {
      path: '/maintenance',
      element: <CommonLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        }
      ]
    }
  ]
};

export default MainRoutes;
